// client/src/views/Interactive_parts/personalPinHandlers.js
export function createPersonalPinHandlers({
  placingPin,
  setPlacingPin,
  personalPins,
  setPersonalPins,
  modalPin,
  setModalPin,
  editPinIdx,
  setEditPinIdx,
}) {
  function deleteAllPins() {
    setPersonalPins([]);
  }

  function handleMapClick(coord) {
    if (!placingPin) return;
    setModalPin({
      x: coord.x,
      y: coord.y,
      label: '',
      colour: '#4285f4',
    });
    setPlacingPin(false);
    setEditPinIdx(null);
  }

  function handlePinMarkerClick(idx) {
    setModalPin(personalPins[idx]);
    setEditPinIdx(idx);
  }

  function handleModalSave({ label, colour }) {
    if (editPinIdx === null) {
      setPersonalPins(pins => [
        ...pins,
        { ...modalPin, label, colour },
      ]);
    } else {
      setPersonalPins(pins =>
        pins.map((pin, i) =>
          i === editPinIdx ? { ...pin, label, colour } : pin
        )
      );
    }
    setModalPin(null);
    setEditPinIdx(null);
  }

  function handleModalDelete() {
    if (editPinIdx !== null) {
      setPersonalPins(pins =>
        pins.filter((_, i) => i !== editPinIdx)
      );
    }
    setModalPin(null);
    setEditPinIdx(null);
  }

  function handleModalCancel() {
    setModalPin(null);
    setEditPinIdx(null);
  }

  return {
    deleteAllPins,
    handleMapClick,
    handlePinMarkerClick,
    handleModalSave,
    handleModalDelete,
    handleModalCancel,
  };
}
